import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  scroll-snap-align: start;
`
